import { CommonProductQueryParams } from '~/api/easy-estimator-api/commonProductQueryParams';
import { staticContentService } from '~/api/local-api/localService';
import { AXIOS_TIMEOUT } from '~/core/constants';
import { ApiUrl } from '~/core/enums';
import { ApplianceModel } from '~/core/models';

const predefinedCookingAppliancesApi = staticContentService.injectEndpoints({
  endpoints: (builder) => ({
    fetchPredefinedCookingAppliances: builder.query<
      ApplianceModel[],
      CommonProductQueryParams
    >({
      query: ({ params }) => ({
        url: ApiUrl.CUSTOMER_SUPPLIED_COOKING_APPLIANCES,
        method: 'GET',
        params,
      }),
    }),
    fetchInStoreCookingAppliances: builder.query<ApplianceModel[], string>({
      query: (url: string) => ({
        url,
        method: 'GET',
        timeout: AXIOS_TIMEOUT,
      }),
    }),
  }),
});

export const {
  useLazyFetchPredefinedCookingAppliancesQuery,
  useLazyFetchInStoreCookingAppliancesQuery,
} = predefinedCookingAppliancesApi;
